import React from "react";
import { Zap, ChevronRight } from "lucide-react";
import "./index.css";
import BundleDialog from "../BundleDialog";

export default function BundleBanner(props) {
  const {
    onClick,
    bundle,
    isOpened,
    onCloseDialog,
    onSelectBundlePack,
    selectedBundle,
  } = props;

  const {
    // code,
    title,
    subtitle,
    rating,
    ctaText,
    trackingId,
    bundles,
    description,
    disclaimer,
    promotionalLabel,
    colorStyle,
    image,
    purchaseNumber,
  } = bundle;

  return (
    <>
      <div className={`bb-banner ${colorStyle}`} id={trackingId}>
        <div className="bb-content-flex">
          <div className="bb-left">
            <div className="bb-header">
              <div>
                <div className="bb-title-wrapper">
                  <h2>{title}</h2>
                  <Zap className="bb-zap" />
                </div>
                <p>{subtitle}</p>
              </div>
            </div>

            <div className="bb-badges">
              {promotionalLabel && (
                <div className="badge badge-highlight">{promotionalLabel}</div>
              )}
              <div className="badge badge-metric">⭐ {rating} stelle</div>
              <div className="badge badge-metric">
                {purchaseNumber}+ prenotazioni
              </div>
            </div>
          </div>

          <button className="bb-btn-base" onClick={onClick}>
            <span className="bb-btn-text">{ctaText}</span>
            <ChevronRight />
          </button>
        </div>
      </div>
      {isOpened && (
        <BundleDialog
          onClose={onCloseDialog}
          image={image}
          title={title}
          subtitle={description}
          suggestTitle={disclaimer}
          items={bundles}
          onSelectBundlePack={onSelectBundlePack}
          selectedBundle={selectedBundle}
        />
      )}
    </>
  );
}
